const server = (window.location.protocol + "//" + window.location.hostname + (window.location.port != "" ? ":"+window.location.port : ""));

export async function getDataFromServer(){
  let data = {}
  let response = await fetch(`${server}/all.json`,
  {
    method: 'GET',
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
  })
  if(response.status === 401){
    console.log("Unauthenticated, redirecting to login screen")
    data = {loggedIn: false}
  }
  if(response.status === 200){
    data = {...(await response.json()),loggedIn: true}
  }
  return data
}

export async function addMeal(meal_name){
  let data = {}
  let response = await fetch(`${server}/meals/${meal_name}`,
  {
    method: "POST",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
  })
  if(response.status === 401){
    console.log("Unauthenticated, redirecting to login screen")
    data = {loggedIn: false}
  }
  if(response.status === 200){
    data = {...(await response.json()),loggedIn: true}
  }
  return data
}

export async function addMealIngredient(meal_id,ingredient_name){
  let data = {}
  let response = await fetch(`${server}/meals/${meal_id}/ingredients/${ingredient_name}`, 
  {
    method: "POST",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
  })
  if(response.status === 401){
    console.log("Unauthenticated, redirecting to login screen")
    data = {loggedIn: false}
  }
  if(response.status === 200){
    data = {...(await response.json()),loggedIn: true}
  }
  return data
}

export function deleteMeal(meal_id){
  fetch(`${server}/meals/${meal_id}`, {
    method: "DELETE",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function scopeMeal(meal_id,in_scope){
  fetch(`${server}/meals/${meal_id}?inScope=${in_scope}`, {
    method: "PUT",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function renameMeal(meal_id,new_name){
  fetch(`${server}/meals/${meal_id}?label=${new_name}`, {
    method: "PUT",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function setItemTick(meal_id,ingredient_id,tick){
  fetch(`${server}/meals/${meal_id}/ingredients/${ingredient_id}?ticked=${tick}`, {
  method: "PUT",
  credentials: 'include',
  headers: {
    "Content-Type": "application/json",
  },
  })
  .then((response) => response.json())
  .then((data) => {
    console.log("Success: ", data);
  })
  .catch((error) => {
    console.error("Error: ", error); 
  });
}

export function setItemStocked(meal_id,ingredient_id,stocked){
  fetch(`${server}/meals/${meal_id}/ingredients/${ingredient_id}?stocked=${stocked}`, {
  method: "PUT",
  credentials: 'include',
  headers: {
    "Content-Type": "application/json",
  },
  })
  .then((response) => response.json())
  .then((data) => {
    console.log("Success: ", data);
  })
  .catch((error) => {
    console.error("Error: ", error); 
  });
}

export function setItemcategory(meal_id,ingredient_id,category){
  fetch(`${server}/meals/${meal_id}/ingredients/${ingredient_id}?category=${category}`, {
  method: "PUT",
  credentials: 'include',
  headers: {
    "Content-Type": "application/json",
  },
  })
  .then((response) => response.json())
  .then((data) => {
    console.log("Success: ", data);
  })
  .catch((error) => {
    console.error("Error: ", error); 
  });
}

export function removeIngredient(meal_id,ingredient_id){
  fetch(`${server}/meals/${meal_id}/ingredients/${ingredient_id}`, {
  method: "DELETE",
  credentials: 'include',
  headers: {
    "Content-Type": "application/json",
  },
  })
  .then((response) => response.json())
  .then((data) => {
    console.log("Success:", data);
  })
  .catch((error) => {
    console.error("Error:", error); 
  });
}

export function renameIngredient(meal_id,ingredient_id,ingredient_name_new){
  fetch(`${server}/meals/${meal_id}/ingredients/${ingredient_id}?label=${ingredient_name_new}`, {
  method: "PUT",
  credentials: 'include',
  headers: {
    "Content-Type": "application/json",
  },
  })
  .then((response) => response.json())
  .then((data) => {
    console.log("Success:", data);
  })
  .catch((error) => {
    console.error("Error:", error); 
  });
}

export async function logIn(username,password){
  //The server answers HTTP 200 for BOTH outcomes: {"status":"ok"} on success
  //and {"status":"bad"} on failure. The "bad" is deliberately opaque (no
  //"wrong password" vs "unknown user" detail - that would let someone
  //enumerate usernames), so the caller shows one generic message.
  //We resolve with that status so the caller decides what to do, and reject
  //when the request never reaches the server (bad reception / no network)
  //so the caller can say "connection failed".
  let response
  try {
    response = await fetch(`${server}/login`, {
      method: "POST",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({username:username,password:password}),
    })
  } catch (error) {
    console.error("Error", error);
    throw error
  }
  let data
  try {
    data = await response.json()
  } catch (error) {
    console.error("Error", error);
    throw error
  }
  console.log("login: " + data.status)
  return data.status
}

// --- dinner plan (ROADMAP "Plan") -------------------------------------------

export function setMealType(meal_id,meal_type){
  fetch(`${server}/meals/${meal_id}?mealType=${meal_type}`, {
    method: "PUT",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export async function createPlan(startDate,meal_ids){
  // a new plan, superseding the current one (history is kept server-side).
  // `meal_ids` is the optional initial sequence, in order. Resolves with the
  // new plan, or {} when the server rejected it (e.g. a bad meal in it).
  let data = {}
  let meals = (meal_ids || []).join(",")
  let url = `${server}/plan?startDate=${startDate}` + (meals ? `&meals=${meals}` : "")
  let response = await fetch(url,
  {
    method: "POST",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
  })
  if(response.status === 200){
    data = {...(await response.json()),loggedIn: true}
  }
  return data
}

export function updatePlanStartDate(startDate){
  fetch(`${server}/plan?startDate=${startDate}`, {
    method: "PUT",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function setPlanCost(cost){
  // the week's shop total against the active plan; null clears it
  const param = (cost === null || cost === undefined) ? "" : cost
  fetch(`${server}/plan?cost=${param}`, {
    method: "PUT",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function setHistoryPlanCost(plan_id, cost){
  // the week's shop total against a finished / superseded plan (backfill); null clears it
  const param = (cost === null || cost === undefined) ? "" : cost
  fetch(`${server}/plan/history/${plan_id}?cost=${param}`, {
    method: "PUT",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function addPlanMeal(meal_id,thickness){
  fetch(`${server}/plan/meals/${meal_id}?thickness=${thickness || 1}`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function setPlanMealThickness(meal_id,thickness){
  fetch(`${server}/plan/meals/${meal_id}?thickness=${thickness}`, {
    method: "PUT",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function movePlanMeal(meal_id,position){
  fetch(`${server}/plan/meals/${meal_id}?position=${position}`, {
    method: "PUT",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function removePlanMeal(meal_id){
  fetch(`${server}/plan/meals/${meal_id}`, {
    method: "DELETE",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export async function finishPlan(){
  // the end-of-week close: the active plan retires to history and every
  // regular meal goes out of scope (extras stays). awaited by the caller -
  // it must have landed before the client re-syncs from the server.
  // resolves with the server's answer, or {} when it never reached 200.
  let data = {}
  let response = await fetch(`${server}/plan/finish`,
  {
    method: "POST",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
  })
  if(response.status === 200){
    data = {...(await response.json()),loggedIn: true}
  }
  return data
}

export async function getPlanHistory(){
  // the finished / superseded plans, newest first, each with its meal
  // sequence - the desaturated history list under the Plan view.
  // resolves with {plans: [...]} (or an empty list when the call fails).
  let data = {plans: []}
  let response = await fetch(`${server}/plan/history`,
  {
    method: "GET",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
  })
  if(response.status === 200){
    data = {...(await response.json()),loggedIn: true}
  }
  return data
}